export default function Pricing() {
    return (
      <div className="bg-white">
       
      </div>
    )
  }
  